import { ReferenceTier } from '@/lib/apollo/query/get-applicant'

export const isSelfServeStudent = (referenceTier: ReferenceTier | undefined): boolean =>
  referenceTier === ReferenceTier.selfServeStudent

export const isSelfServeTier = (referenceTier: ReferenceTier | undefined): boolean =>
  referenceTier === ReferenceTier.selfServe || isSelfServeStudent(referenceTier)

export const showGoodlordControlBanner = (referenceTier: ReferenceTier | undefined) => {
  return isSelfServeTier(referenceTier)
}
